var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLogo)?_c('img',{class:_vm.$style.logo,attrs:{"alt":"User Portal","src":_vm.logoUrl},on:{"error":_vm.imageLoadError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }